import React from "react";
import { Box, Tabs, Tab, Typography, Grid } from "@mui/material";
import { useCheckMenuPermission } from "hooks/useCheckMenuPermission";
import { enterpriseTokens } from "styles/theme";

const CustomTabs = ({ tabValue, handleTabChange, tabs = [], parentSx }) => {
    const { hasPermission } = useCheckMenuPermission();

    return (
        <Grid size={12}>
            <Box
                sx={parentSx ? parentSx : {
                    width: "100%",
                    borderBottom: `1px solid ${enterpriseTokens.lineSoft}`,
                    overflowX: "auto",
                    whiteSpace: "nowrap",
                    p: 0,
                    backgroundColor: "#FFFFFF",
                    "-webkit-overflow-scrolling": "touch",
                }}
            >
                <Tabs
                    value={tabValue}
                    onChange={handleTabChange}
                    TabIndicatorProps={{ style: { display: "none" } }}
                    variant="scrollable"
                    scrollButtons="auto"
                    allowScrollButtonsMobile
                    sx={{
                        justifyContent: "flex-start !important",
                        alignItems: "flex-start",
                        "& .MuiTabs-flexContainer": {
                            justifyContent: "flex-start !important",
                            gap: "18px",
                        },
                        "& .MuiTabs-scrollButtons": {
                            width: 30,
                            color: enterpriseTokens.slate,
                        },
                    }}
                >
                    {/* {tabs?.filter((item) => hasPermission(item?.permissionKey) > 0)?.map((label, index) => ( */}
                    {tabs?.map((label, index) => (
                        <Tab
                            key={index}
                            label={
                                <Box sx={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                    <Typography
                                        sx={{
                                            fontWeight: 700,
                                            fontSize: "12px",
                                            lineHeight: "18px",
                                            color: tabValue === index ? enterpriseTokens.primary : enterpriseTokens.muted,
                                            fontFamily: "Inter, Outfit, sans-serif",
                                        }}
                                    >
                                        {label?.label}
                                    </Typography>
                                </Box>
                            }
                            sx={{
                                textTransform: "none",
                                minWidth: "auto",
                                minHeight: "34px",
                                padding: "7px 0",
                                borderRadius: 0,
                                backgroundColor: "transparent",
                                borderBottom: `2px solid ${tabValue === index ? enterpriseTokens.primary : "transparent"}`,
                                "&:hover": {
                                    backgroundColor: "transparent",
                                },
                            }}
                        />
                    ))}
                </Tabs>
            </Box>
        </Grid>
    );
};

export default CustomTabs;
